import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../assets/img/PosterFTschriftV2.png';
import facebookicon from '../assets/img/facebookicon.svg';
import instaIcon from '../assets/img/instaIcon.svg';
import GalerieIcon from '../assets/img/Galerie.svg';
import { HashLink } from 'react-router-hash-link';
import { BrowserRouter as Router } from "react-router-dom";

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [navExpanded, setNavExpanded] = useState(false);   // 👈 NEU

  // Scroll-Überwachung
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else if (!navExpanded) {
        // nur zurücksetzen, wenn mobile Menü NICHT offen ist
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [navExpanded]);

  // Wenn mobile Menü geöffnet → scrolled aktiv erzwingen
  useEffect(() => {
    if (navExpanded) {
      setScrolled(true);
    } else if (window.scrollY < 50) {
      setScrolled(false);
    }
  }, [navExpanded]);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar
        expand="md"
        className={scrolled ? "scrolled" : ""}
        expanded={navExpanded}                   // 👈 NEU
        onToggle={(expanded) => setNavExpanded(expanded)} // 👈 NEU
      >
        <Container>
          <Navbar.Brand href="/">
            <img src={logo} alt="Logo" style={{ width: '300px', height: 'auto' }} />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Start</Nav.Link>
              <Nav.Link href="#Vorstandschaft" className={activeLink === 'Vorstandschaft' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('Vorstandschaft')}>Vorstandschaft</Nav.Link>
              <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Über uns</Nav.Link>
              <Nav.Link href="#Formular" className={activeLink === 'Formular' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('Formular')}>Mitgliedschaft</Nav.Link>
            </Nav>

            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.facebook.com/share/1BY1oJA3Fa/" target="_blank" rel="noopener noreferrer">
                  <img src={facebookicon} alt="" />
                </a>
                <a href="https://www.instagram.com/felsenteufel?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                  <img src={instaIcon} alt="" />
                </a>
                <a href="http://teufelgalerie.magix.net/album/all-albums/" target="_blank" rel="noopener noreferrer">
                  <img src={GalerieIcon} alt="" />
                </a>
              </div>

              <HashLink to='#connect'>
                <button className="vvd"><span>Schreib uns</span></button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
